import { Product } from '@@types'
import { useTranslation } from 'react-i18next'

import useProductsSimilarModal from '@widgets/products-similar/hooks/useProductsSimilarModal'

import Button from '@shared/ui/button'


interface SimilarProductsTriggerProps {
  product: Product;
  className?: string;
  onClick?: () => void;
}

export default function SimilarProductsTrigger (
  props: SimilarProductsTriggerProps,
) {
  const { t: tc } = useTranslation('cart')
  const { product, className, onClick } = props
  const { openProductsSimilarModal } = useProductsSimilarModal()

  const handleClick = () => {
    openProductsSimilarModal(product)

    if (onClick) {
      onClick()
    }
  }

  return (
    <Button className={className} theme="secondary" onClick={handleClick}>
      {tc('replace_with_similar')}
    </Button>
  )
}
